import "./Preloader.css";

interface PreloaderProps {
  size?: "small" | "normal";
}

export const Preloader = ({ size = "normal" }: PreloaderProps) => {
  return <div className={`preloader-${size}`}></div>;
};
